module.exports = __webpack_public_path__ + "img/kikaku.accb156c.jpeg";